//OurPhilosophy.js
import React from 'react';
import './OurPhilosophy.css';

const OurPhilosophy = () => {
  return (
    <section className="philosophy-section">
      <div className="philosophy-content">
        <div className="philosophy-header">
          <h2>Our philosophy</h2>
          <p>
            At Cognitva, we believe the future of industry lies in intelligent infrastructure — not just smarter tools. We don't just build software; we build systems that think, adapt, and evolve. Our modular AI platform empowers enterprises to navigate complexity, automate compliance, and make intelligence their competitive edge. We're driven by purpose, grounded in trust, and obsessed with simplicity at scale.
          </p>
        </div>

        <div className="vision-mission-container">
          <div className="philosophy-image">
            <img src="/images/imagePlaceholder.svg" alt="Cognitiva Logo" />
          </div>
          <div className="vision-mission-text">
            <div className="card">
              <h3>— VISION</h3>
              <p>
                To power the future of industries with adaptive intelligence — enabling organizations to think, learn, and act through AI that scales seamlessly across domains
              </p>
              <p className="small-text">
                Cognitva envisions a world where every enterprise, regardless of sector, can tap into a unified intelligence layer that transforms complexity into strategic advantage
              </p>
            </div>
            <div className="card">
              <h3>— MISSION</h3>
              <p>
                To build a cross-industry AI platform that delivers reusable copilots, regulatory intelligence, and predictive analytics — enabling enterprises to automate, scale, and lead with confidence.
              </p>
              <p className="small-text">
                Starting with legal and healthcare, we aim to democratize access to domain-specific AI across sectors — through modular architecture, enterprise-grade security, and seamless human-AI collaboration
              </p>
            </div>
          </div>
        </div>

        <div className="philosophy-divider"></div>
      </div>
    </section>
  );
};

export default OurPhilosophy;